import React, { useEffect } from "react";
import styled from "styled-components";

import { ModalWrapper, NormalText } from "../common.styles";
import { WarningIcon } from "../../../newerhome/subaccounts/common/assets/Icons";
import Button, { LightButton } from "../../../../../../library/otherButton/Button";

const ConfirmationModal = ({
    closeModal,
    isSubmitting,
    title,
    details,
    handleContinueClick,
    buttonText,
    lightButText,
}) => {
    useEffect(() => {
        document.body.classList.add("backdrop-init");

        return () => {
            document.body.classList.remove("backdrop-init");
        };
    }, [closeModal]);

    return (
        <div className="modal">
            <div className="fadeIn animated modal-backdrop">
                <ConfirmationModalStyled className="animated kudaFadeInUp">
                    <h3>{title}</h3>
                    <div>
                        <WarningIcon />
                    </div>
                    <NormalText>{details}</NormalText>
                    <div className="catalogue-modal__buttons-wrap">
                        <LightButton
                            text={lightButText || "No"}
                            width="157.5px"
                            onButtonClick={closeModal}
                        />
                        <Button
                            text={buttonText || "Yes"}
                            width="157.5px"
                            onButtonClick={handleContinueClick}
                            isSubmitting={isSubmitting}
                        />
                    </div>
                </ConfirmationModalStyled>
            </div>
        </div>
    );
};

const ConfirmationModalStyled = styled(ModalWrapper)`
    padding: 46px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 415px;

    h3 {
        margin-bottom: 52px;
        font-weight: 800;
        color: #000;
    }
    p {
        margin-top: 60px;
        margin-bottom: 44px;
        text-align: center;
    }

    @media (max-width: 414px) {
        padding: 32px 20px;
    }
`;

export default ConfirmationModal;
